module.exports = __webpack_public_path__ + "static/img/tx_zzh.589ad0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/team/tx_zzh.png
// module id = rDwH
// module chunks = 0